module.exports = __webpack_public_path__ + "img/airlines-ua.e2d2663f.svg";